/*
 * @Descripttion: radio单选组件
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */

import React, { useState } from 'react';
import { Radio } from '@alifd/next';
import styles from './index.module.scss';

/**
 * opType 固定为 'EQ'
 * @param {*} tagItem 整个标签的信息
 * @param {*} changeData 把组件的值提交到父组件，改变父组件的值
 * @return {*}
 */
const TagRadio = ({
  tagItem = {}, changeData = (data) => {
  },
}) => {
  const [data, setData] = useState(tagItem?.opValue?.param_list?.[0]?.param_id?.[0]); // radio选中的值

  /**
   * 选择时改变要处理成字符串形式传给父组件
   */
  const changeValue = (val) => {
    setData(val);
    changeData({
      opValue: {
        label_id: tagItem.id,
        param_list: [
            {
                param_id: [val]
            }
        ]
      },
      opType: 'EQ'
    });
  };

  return (
    <div className={`${styles['tag-checkbox']} tag-width`}>
      <Radio.Group value={data} onChange={(val) => changeValue(val)}>
        {
          tagItem.value.map((its, ins) => (<Radio
            style={{ marginBottom: '10px', marginLeft: '0px', marginRight: '8px' }}
            key={ins}
            value={its.realValue}
          >
            {its.fieldValue}
          </Radio>))
        }
      </Radio.Group>
      {
        !data && <div style={{ color: "#f33" }}
          className={`iconfont icon-icon4-30 ${styles['tag-error-select']}`}
        >请选择{tagItem.labelDescription}
        </div>
      }
    </div>
  );
};
export default TagRadio;
